module.exports = __webpack_public_path__ + "static/media/hearthstone.d83eb492.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/games/hearthstone.jpg
// module id = 44
// module chunks = 0